<template>
    <div>
        <topbar></topbar>

        <nav class="navbar mai-sub-header">

            <div class="container">
                <!-- Mega Menu structure-->
                <nav class="navbar navbar-toggleable-sm">
                    <b-button v-b-toggle.mai-navbar-collapse
                            aria-controls="#mai-navbar-collapse" aria-expanded="false" aria-label="Toggle navigation"
                            class="navbar-toggler hidden-md-up collapsed">
                        <div class="icon-bar">
                            <span></span>
                            <span></span>
                            <span></span>
                        </div>
                    </b-button>
                    <b-collapse id="mai-navbar-collapse" class="navbar-collapse collapse mai-nav-tabs">
                        <main-menu></main-menu>
                    </b-collapse>
                </nav>
            </div>
        </nav>
    </div>
</template>

<script>
    import mainMenu from "../menus/mainmenu.vue"
    import topbar from "../topbar/topbar.vue"

    export default {
        components: {
            mainMenu,
            topbar
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/layout/default/header.vue